import { CheckboxField, Flex } from '@aws-amplify/ui-react'
import React, { ChangeEventHandler } from 'react'

export default function OptionRadio({ correctIndices, index, onChange }: { index: number, correctIndices: (number | null)[] | null | undefined, onChange: ChangeEventHandler<HTMLInputElement> | undefined }) {
    return <Flex color='white'><b>{String.fromCharCode(65 + index)}</b><CheckboxField   backgroundColor={'white'} borderRadius={"5px"} value={String.fromCharCode(65 + index)} checked={correctIndices?.includes(index)} label={undefined} name={''} onChange={onChange} /></Flex>
}

